<template>
  <v-select
    v-if="data.class === 'select'"
    :items="data.options"
    item-text="text"
    item-value="value"
    :label="data.text"
    :hint="data.placeholder"
    v-model="data.value"
    persistent-hint
    :hide-details="!(!!data.placeholder)"
  ></v-select>
  <v-select
    v-else-if="data.class === 'multiple'"
    v-model="data.value"
    :items="data.options"
    :label="data.text"
    :hint="data.placeholder"
    item-text="text"
    item-value="value"
    multiple
    persistent-hint
    :hide-details="!(!!data.placeholder)"
  ></v-select>
</template>

<script>
export default {
  name: "Select",
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};
</script>

<style>
</style>